import classNames from 'classnames'

import styles from './mail.module.scss'
import type { BrandColor } from '@app-types/color'
import type { IconComponent } from '@components/icons/types'

/** Mail icon 💌  */
export const Mail: IconComponent<Props> = ({
    width,
    height,
    color,
    className,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        className={classNames(
            className,
            styles.mail,
            styles[`stroke-${color}`],
        )}
        viewBox='0 0 22 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <path d='M21 14C21 15.1 20.1 16 19 16H3C1.9 16 1 15.1 1 14V3C1 1.9 1.9 1 3 1H19C20.1 1 21 1.9 21 3V14Z' />
        <path d='M1.65991 1.5L10.9999 8.5' />
        <path d='M20.21 1.58984L11 8.49984' />
    </svg>
)

interface Props {
    /** Main color */
    color?: BrandColor
}
